import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'

interface IResGetUsersDeviceStatus {}

export const apiGetUsersDeviceStatus = async ({}: IResGetUsersDeviceStatus = {}) => {
    return await apiGet<IUserDeviceStatus>(createUrl(`/protectee/summary/device-status`, {}))
}

const useQueryGetUsersDeviceStatus = (enabled = true) => {
    return useQuery({
        enabled: enabled,
        queryKey: QueryCacheKeys.user.getUsersDeviceStatus(),
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersDeviceStatus()
            return data
        }
    })
}

export default useQueryGetUsersDeviceStatus

export interface IUserDeviceStatus {
    emergency: number
    online: number
    charging: number,
    offline: number
}
